import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Kyc.css";
import kycValidation from "../../PDF/KYC Validation Process CVL.pdf";
// import camspdf from "../../PDF/KYC Validation Process-CAMSKRA.pdf";
import camspdf from "../../PDF/KYC Validation Process- CAMS KRA.pdf";
import cvlkpdf from "../../PDF/KYC Validation Process-CVLKRA.pdf";
import SEBI from "../../PDF/SEBI-FAQs on KYC norms for the securities market May 2024.pdf";
import KycForm from "./KycForm";
import KycForm2 from "./KycForm2";
import { trackEvent, trackPageView } from "../utils/tracking";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Kyc() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/KycUpdate",
      "jmf_insights_kyc-update"
    );
    // trackPageView("http://localhost:710/KycUpdate", "jmf_insights_kyc-update");

    trackEvent({
      category: "Static Page",
      action: "KYCUpdate Page Loaded",
      label: "jmf_insights_kyc-update",
      // value: 1,
    });
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Update your KYC details online with JM Financial Mutual Fund to ensure compliance and uninterrupted investment services. A quick and secure process for all investors."
          />
          <title>
            KYC Update | Complete Your KYC for Seamless Investments | JM
            Financial Mutual Fund
          </title>
        </Helmet>
      </HelmetProvider>

      <div className="Kyc-main">
        <Container>
          <Row>
            <Col>
            <nav aria-label="Breadcrumb">
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i className="fa fa-home"></i>
                    <span className="sr-only">Home</span>
                  </a>{" "}
                  <i className="fa fa-angle-right"></i>
                </li>
                <li>Know Your KYC Status</li>
              </ul>
            </nav>
            </Col>
          </Row>
        </Container>

        <Container>
          <main className="Kyc-inner-main">
            <h1 className="kyc-header-title">Know Your KYC Status</h1>
            <p style={{ textAlign: "center" }}>
              To know your KYC Status simply enter your PAN in the space
              provided below, enter the Captcha and click Submit.
            </p>

            <KycForm />
            {/* <KycForm2 /> */}
            <p>
              <a href={SEBI} target="_blank">
                View FAQs on KYC Norms for the Securities Market
              </a>
              {/* to view the FAQ's KYC Norms For The Securities Market. */}
            </p>

            <h2>If the Status is KYC “Validated”</h2>
            <p>
              If KYC Status is “KYC Validated” then nothing needs to be done,
              you can invest in any scheme.
            </p>

            <h3>If the Status is KYC “Registered” but not “Validated”</h3>
            <p>
              If the KYC status is “Registered” but not “Validated”, investors
              will still be able to continue their existing SIPs and initiate
              additional purchase transactions with AMCs where they are already
              holding investments.{" "}
            </p>

            <p>
              To check the latest KYC status, please enter your PAN in the space
              provided above.{" "}
            </p>

            <p>
              You may also visit the KRA site from the links and options given,
              input your PAN, and submit to see your KYC Status with the details
              of the proof you have submitted for your KYC.
            </p>
            <ul>
              <li>
                <a href="https://www.cvlkra.com/">CVL KRA - KYC Enquiry</a>
              </li>
              <li>
                <a href="https://www.camskra.com/">CAMSKRA - My KYC Status</a>
              </li>
              <li>
                <a href="https://kra.ndml.in/kra-eb/jsps/pos/KYCClientInquiry_NEW.jsp">
                  NSDL KRA - Inquiry on KYC
                </a>
              </li>
              <li>
                <a href="https://www.nsekra.com/">NSE KRA - KYC Inquiry</a>
              </li>
              <li>
                <a href="https://www.karvykra.com/UPanSearchGlobalWithPanExempt.aspx">
                  KARVY KRA - KYC Enquiry
                </a>
              </li>
            </ul>
            <p>
              However, investor can transact with any other new Mutual Fund by
              providing the KYC form with valid documents again. It is advised
              to use the Aadhar card as the Officially valid document and
              validate the KYC. This may avoid the need to submit KYC form and
              OVD documents again. Here is a list of OVDs:
            </p>
            <ol>
              <li>Passport </li>
              <li>Driving license </li>
              <li>Proof of possession of Aadhaar (as issued by UIDAI) </li>
              <li>
                Voter's Identity Card issued by the Election Commission of India{" "}
              </li>
              <li>
                Job card issued by NREGA duly signed by an officer of the State
                Government{" "}
              </li>
              <li>
                Letter issued by the National Population Register containing
                details of name and address.{" "}
              </li>
            </ol>
            <p>
              Here is a list of the KRA’s along with their website where you may
              visit to get your status changed to “KYC Validated”:{" "}
            </p>

            <h3>If the Status is KYC On Hold / Rejected</h3>
            <p>
              If the KYC status is "On Hold” or “Rejected”, it indicates that
              the KYC documents are not in order or mobile number, and email ID
              of the mutual fund investors have not been verified. All financial
              transactions, as well as some non-financial transactions, will be
              rejected and processed only after the Modify KYC or New KYC form
              is submitted along with supporting documents.
            </p>
            <p>
              This could affect ongoing SIP transactions, redemptions, and other
              activities. Investors must validate their email and mobile number
              to continue transacting in their existing mutual fund schemes.
              Additionally, they should complete the KYC Validation process to
              avoid having to submit extra documents for future investments.
            </p>
            <p>
              <strong>Validate your contact details</strong> in your KYC records
              by clicking your KRA links given below:
            </p>
            <ul>
              <li>
                <a href="https://www.camskra.com/PanDetailsUpdate.aspx">
                  CAMS KRA
                </a>
              </li>
              <li>
                <a href="https://validate.cvlindia.com/CVLKRAVerification_V1/">
                  CVL KRA
                </a>
              </li>
              <li>
                <a href="https://kra.ndml.in/ClientInitiatedKYC-webApp/#/ClientinitiatedKYC">
                  NSDL KRA
                </a>
              </li>
              <li>
                <a href="https://www.karvykra.com/KYC_Validation/Default.aspx">
                  KARVY KRA
                </a>
              </li>
              <li>
                <a href="https://kra.ndml.in/kra-eb/jsps/pos/KYCClientInquiry_NEW.jsp">
                  NSDL KRA - Inquiry on KYC
                </a>
              </li>
            </ul>
            <p>
              You may visit the website of any of the KRAs given below and
              change your KYC status to “Validated”{" "}
            </p>
            <p>
              Effectively, if the KYC status is anything but not KYC Validated,
              there will be restrictions on the investor’s ability to transact.
              Kindly get your KYC changed to “Validated” to be able to transact
              without hassle in mutual funds. Investor whose KYC is registered
              with CVL and CAMS KRA KYC can validate their KYC, if Aadhaar
              provided as one of the KYC OVD documents by clicking the below
              link. For other KRA like Dotex NDML etc. Investors need to Submit
              Modify KYC form along with supporting documents.
            </p>
            <ul>
              <li>
                <a href="https://validate.cvlindia.com/CVLKRAVerification_V1/">
                  CVL KRA
                </a>
              </li>
              <li>
                <a href="https://www.camskra.com/PanDetailsUpdate.aspx">
                  CAMS KRA
                </a>
              </li>
            </ul>
            <div style={{ display: "flex", gap: 15 }}>
              <div className="iap-download">
                <a target="_blank" href={camspdf} rel="noreferrer">
                  {" "}
                  KYC Validation Process-CAMSKRA
                </a>
              </div>
              <div className="iap-download">
                <a target="_blank" href={cvlkpdf} rel="noreferrer">
                  {" "}
                  KYC Validation Process-CVLKRA
                </a>
              </div>
            </div>

            <p>
              In case of any queries, please feel free to get in touch with us
              at <a href="mailto:Investor@JMFL.com">Investor@JMFL.com</a> or
              call us at <a href="tel:+91 22 61987777 ">+91 22 61987777 </a> /{" "}
              <a href="+91 22 33797777">33797777</a> or our toll free number{" "}
              <a href="tel:1800-1038-345">1800-1038-345</a>.
            </p>
          </main>
        </Container>
      </div>
    </>
  );
}
